import styled from 'styled-components'

export const H1 = styled.h1`
  text-align: center;
  word-break: break-word;
  font-size: ${(props) => (props.mobile ? '1.5rem' : '2rem')};
  color: var(--azul-escuro);
`
